var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service"},[_c('div',{staticClass:"serviceCenter"},[_c('router-link',{staticClass:"avatarArea",attrs:{"tag":"div","to":"/myDoctor/recentChat"}},[_c('img',{attrs:{"src":require("../../../static/img/我的医生.png"),"alt":""}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-10c4b43a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/service/serviceIndex.vue
// module id = 1344
// module chunks = 382